import { render, staticRenderFns } from "./WxUserinfoForm.vue?vue&type=template&id=5c484dda&"
import script from "./WxUserinfoForm.vue?vue&type=script&lang=js&"
export * from "./WxUserinfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports